// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;
 
export const BASEURL = `https://kuwait-cron-api.starcinemas.com`;
 
// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://kuwait-cron-api.starcinemas.com`;
 
export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;
export const STAR_OMAN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjcyMDliYWI5LWY3YzktNDllZS05MWZjLWI2Y2M2NTA1NDA3ZSIsImlhdCI6MTc3NjI1NzU2NX0.QooOLjMvKvzvxWkW3yfKjuo9IGU48DYK30FtmZHGbV`
export const TOKEN = STAR_OMAN



// WEBPACK FOOTER //
// ./src/config/index.js